import faq from "./parts/_faq.js";
import formsSelect from "./forms/_select.js";
import otherHeadAlert from "./others/_head-alert.js";
import buttonsFavorite from "./buttons/_favorite.js";
import basicsBadge from './basics/_badge.js';
import othersSearchMenu from "./others/_search-menu.js";
import othersSearchList from "./others/_search-list.js";
import cardsEstate from "./cards/_estate.js";
import othersSelectSite from "./others/_select-site.js";
import othersSelectSearch from "./others/_select-search.js";
import hamburger from "./others/_hamburger.js";
const components = () => {
    faq();
    formsSelect();
    otherHeadAlert();
    buttonsFavorite();
    basicsBadge();
    othersSearchMenu();
    othersSearchList();
    cardsEstate();
    othersSelectSite();
    othersSelectSearch();
    hamburger();
}

export default components;
